import { makeStyles, Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => ({
    settingsContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flexGrow: 2,
        maxWidth: '100vw',
        //width: '100%',
        //maxHeight: '100%',
    },

    settingsHeader: {
        position: 'absolute',
        left: 0,
        right: 0,
        margin: 0,
        textAlign: 'center',
        textTransform: 'capitalize',
    },

    backArrow: {
        color: '#f1f1f1',
        cursor: 'pointer',
    },

    formControl: {
        margin: theme.spacing(1),
        minWidth: 300,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },

    previewBox: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        border: '1px solid #3F3F3F',
        borderRadius: '5px',
        backgroundColor: '#202122',
        color: 'gray',
        width: '300px',
        height: '225px',
        overflow: 'hidden',
        [theme.breakpoints.down('xs')]: {
            width: 'calc(100% - 40px)',
        },
    },

    previewBoxMessage: {
        width: '100%',
        textAlign: 'center',
    },

    cameraRow: {
        borderTop: '1px solid #3F3F3F',
        padding: '20px',
        // alignItems: 'center',
    },

    settingsRow: {
        // borderTop: '1px solid #3F3F3F',
        padding: '20px',
        // minHeight: '350px',
        // alignItems: 'center',
    },

    fullHeightContainer: {
        height: '100%',
        padding: '20px',
        ['@media (max-width: 960px)']: {
            padding: '0px',
        },
    },

    settingsRowOneColumn: {
        borderTop: '1px solid #3F3F3F',
        padding: '20px 0px',
        minHeight: '100px',
        alignItems: 'flex-start',
        justifyContent: 'center',
    },

    profileSettingsItemText: {
        '&.MuiListItemText-root': {
            minWidth: '200px',
            maxWidth: '300px',
            width: '50%',
        },
    },

    settingsRowLabelControlContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },

    smallTypography: {
        fontSize: '80%',
    },

    audioErrorChip: {
        height: '2.5rem',
        '& .MuiChip-label': {
            paddingLeft: 16,
            paddingRight: 32,
        },
        '& .MuiChip-icon': {
            marginLeft: 16,
        },
    },

    settingsRowIcon: {
        color: '#999999',
        marginRight: '1rem',
    },

    settingsRowLabelTypography: {
        lineHeight: '3',
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
    },

    settingsRowLabelStatus: {
        display: 'flex',
        alignItems: 'center',
        // marginRight:'-1rem'
    },

    icon: {
        color: '#5D5D5D',

        '&.MuiSelect-iconOpen': {
            zIndex: 10000,
            color: '#F9CC04',
        },
    },

    // checkboxContainer: {
    //     position: "absolute",
    //     left: "10px",
    //     top: "7px",
    //     paddingTop: '3px',
    //     paddingBottom: '3px',
    // },

    // audioInputListContainer: {
    //     height: '100%',
    //     padding: '6px 0px',
    //     border: '1px solid #3F3F3F',
    //     borderRadius: '20px',
    // },

    // audioInputListOverview: {
    //     minWidth: '350px',
    //     width: '100%',
    //     maxHeight: '100%',
    //     overflowY: 'auto',
    //     padding: 0,
    // },

    audioInputList: {
        minWidth: '350px',
        width: '100%',
        border: '1px solid #3F3F3F',
        borderRadius: '20px',
        maxHeight: '400px',
        overflowY: 'auto',
        padding: 0,
        '& .MuiListItemIcon-root': {
            minWidth: 'unset',
        },
    },

    audioInputListItemText: {
        paddingLeft: '6px',
        margin: 0,
        '& .MuiTypography-root': {
            color: '#f1f1f1',
        },
    },

    audioInputListItemTextSelected: {
        '& .MuiTypography-root': {
            color: '#f9cc04',
        },
    },

    audioInputListOverviewSectionExternalInputs: {
        //'& .MuiListItem-root': {
        //    paddingTop: 2,
        //    paddingBottom: 2,
        //},
        '& .MuiTypography-body1': {
            fontSize: '13px',
        },
    },

    audioInputRow: {
        transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        cursor: 'pointer',
        paddingTop: '5px',
        paddingBottom: '5px',
        paddingLeft: '8px',

        '&:hover': {
            textDecoration: 'none',
            // backgroundColor: 'rgba(0, 0, 0, 0.04)',
            backgroundColor: 'rgb(255 255 255 / 10%)',
        },
    },

    audioInputIcon: {
        // '& .MuiListItemIcon-root': {
        minWidth: '20px',
        // },
    },

    checkboxIcon: {
        height: 9,
        width: 9,
        borderRadius: 5,
        border: '1px solid #F1F1F1',
        backgroundColor: '#transparent',

        '$root.Mui-focusVisible &': {},
        'input:hover ~ &': {},
        'input:disabled ~ &': {},
    },

    checkedIcon: {
        backgroundColor: '#F9CC04',
        borderRadius: 5,
        '&:before': {
            display: 'block',
            width: 9,
            height: 9,
            content: '""',
        },
        'input:hover ~ &': {},
    },

    settingsTextField: {
        width: '300px',
    },

    centerContent: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
    },

    flexColumnSpaceBetweenContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
    },

    recordingInputLabel: {
        display: 'none',
        // '& label + .MuiInput-formControl': {
        //     margin: 0,
        // },
    },

    testClass: {
        background: 'blue',
    },

    centerText: {
        textAlign: 'center',
    },

    buttonSpacer: {
        width: '100%',
        height: '50px',
        display: 'table',
    },

    settingsItemText: {
        minWidth: '175px',
        flex: 'unset',
    },

    overviewSectionRoundedSelectSmallerLabel: {
        '& .MuiSelect-root': {
            fontSize: '13px',
        },
    },

    bottomChecklistContainer: {
        display: 'flex',
        width: '100%',
        height: '59px',
        paddingLeft: '110px',
        borderTop: '1px solid #3F3F3F',
        alignItems: 'center',
        backgroundColor: '#202122',
        justifyContent: 'flex-end',
    },

    mobileBottomChecklistContainer: {
        display: 'flex',
        width: '100%',
        height: '59px',
        paddingLeft: '10px',
        borderTop: '1px solid #3F3F3F',
        alignItems: 'center',
        backgroundColor: '#202122',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('xs')]: {
            paddingLeft: '0',
        },
    },

    checklistItemGroup: {
        display: 'flex',
        flexGrow: 1,
        marginLeft: '20px',
    },

    mobileChecklistItemGroup: {
        display: 'flex',
        marginLeft: '20px',
    },

    checklistItem: {
        width: '80px',
        textAlign: 'center',

        '& .MuiSvgIcon-root': {
            width: '20px',
        },
        [theme.breakpoints.down('xs')]: {
            width: '60px',
        },
    },

    checklistText: {
        fontSize: '12px',
        lineHeight: '12px',
        color: '#888',
        height: '24px',
    },

    checklistContainerButton: {
        background: '#F9CC04 !important',
        borderRadius: '30px',
        height: '40px',
        marginRight: '20px',

        '&:hover': {
            background: '#F9CC04',
        },

        '& .MuiButton-label': {
            fontSize: '14px',
            color: '#202122',
            textTransform: 'none',
            // [theme.breakpoints.down('xs')]: {
            //     marginLeft: 20
            // }
        },
        [theme.breakpoints.down('xs')]: {
            flex: 1,
        },
    },
    upgradeButton: {
        background: '#F9CC04 !important',
        borderRadius: '30px',
        height: '32px',
        marginRight: '20px',

        '&:hover': {
            background: '#F9CC04',
        },

        '& .MuiButton-label': {
            fontSize: '14px',
            color: '#202122',
            textTransform: 'none',
        },
    },
}))

export default useStyles
